(function ($, Drupal, bootstrap) {
  $.fn.openModal = function () {
    const options = {
      backdrop: true,
      keyboard: true,
      focus: true,
    };
    // eslint-disable-next-line no-new
    const modal = new bootstrap.Modal(this, options);
    modal.show();
    jQuery('.modal .close_link_modal').on('click', () => {
      modal.hide();
    });
  };
// eslint-disable-next-line no-undef
}(jQuery, Drupal, bootstrap));
